<template>
<div id="frame">
    <card :title="title" :subTitle="subtitle" v-if="tick === 1" id="frame">
        <!-- Eingabe -->
        <div class="w3-padding w3-white notranslate">
            <div class="table-responsive">
            <table class="table table-striped">  
            <thead class="thead-dark">
                <tr>
                <th>Pfand</th>
                <th>Preis</th>
                <th><center>Menge</center></th>
                </tr>
            </thead>
            <tbody>
                <tr>      
                <td><label for="pfand12">24er Kasten 0,33l Glas vollst.</label></td>
                <td>€ 5,10</td>
                <td><center><input type="number" class="form-control" v-model="pfand12" id="inputmenge"></center></td>    
                </tr>
                <tr>      
                <td><label for="pfand1">24er Kasten Glas vollst.</label></td>
                <td>€ 3,42</td>
                <td><center><input type="number" class="form-control" v-model="pfand1" id="inputmenge"></center></td>    
                </tr>
                <tr>
                <td><label for="pfand2">20er Kasten Glas vollst.</label></td>
                <td>€ 3,10</td>
                <td><center><input type="number" class="form-control" v-model="pfand2" id="inputmenge"></center></td>
                </tr>
                <tr>
                <td><label for="pfand3">11er Kasten Glas vollst.</label></td>
                <td>€ 2,38</td>
                <td><center><input type="number" class="form-control" v-model="pfand3" id="inputmenge"></center></td>
                </tr>
                <tr>
                <td><label for="pfand4">6er Kasten Glas vollst.</label></td>
                <td>€ 2,40</td>
                <td><center><input type="number" v-model="pfand4" class="form-control" id="inputmenge"></center></td>
                </tr>
                <tr>
                <td><label for="pfand11">12er Plastik/20er Glas vollst.</label></td>
                <td>€ 4,50</td>
                <td><center><input type="number" v-model="pfand11" class="form-control" id="inputmenge"></center></td>
                </tr>
                <tr>
                <td><label for="pfand5">12er Kasten Plastik vollst.</label></td>
                <td>€ 3,30</td>
                <td><center><input type="number" v-model="pfand5" class="form-control" id="inputmenge"></center></td>
                </tr>
                <tr>
                <td><label for="pfand6">6er Kasten Plastik vollst.</label></td>
                <td>€ 3,00</td>
                <td><center><input type="number" v-model="pfand6" class="form-control" id="inputmenge"></center></td>
                </tr>
                <tr>
                <td><label for="pfand10">Kasten leer</label></td>
                <td>€ 1,50</td>
                <td><center><input type="number" v-model="pfand10" class="form-control" id="inputmenge"></center></td>
                </tr>
                <tr>
                <td><label for="pfand7">Mehrweg-Flasche</label></td>
                <td>€ 0,15</td>
                <td><center><input type="number" v-model="pfand7" class="form-control" id="inputmenge"></center></td>
                </tr>
                <tr>
                <td><label for="pfand8">Einweg-Flasche/Dose</label></td>
                <td>€ 0,25</td>
                <td><center><input type="number" v-model="pfand8" class="form-control" id="inputmenge"></center></td>
                </tr>
                <tr>
                <td><label for="pfand9">Glasflasche(Bier)</label></td>
                <td>€ 0,08</td>
                <td><center><input type="number" v-model="pfand9" class="form-control" id="inputmenge"></center></td>
                </tr> 
            </tbody>    
            </table>
            </div>
                <button class="btn btn-sm btn-success float-right" v-on:click="nextTick()" type="button">bestätigen</button>
            </div>
        </card>

    <card :title="titleSignature" :subTitle="subtitle" v-if="tick === 2" id="frame">
        <!-- unterschrift -->
        <div class="signature">
        <VueSignaturePad
            width="300px"
            height="150px"
            ref="signaturePad"
            saveType="image/png"
            class="pad"
        />
        <p class="instruction">Bitte hier untershreiben!</p>
        </div>
        <button class="btn btn-sm btn-danger float-left" v-on:click="cancel()" type="button">abbrechen</button>    
        <button class="btn btn-sm btn-success float-right" v-on:click="saveSign()" type="button">bestätigen</button>
    </card>

    <card :title="title" :subTitle="subtitle" v-if="tick === 3" id="frame">
        <!-- bestätigen -->
        <div class='table-responsive'>
            <table class='table table-striped'>
                <thead>
                    <tr>
                        <th>Bez.</th>
                        <th>Menge   </th>
                        <th>Preis   </th>
                        <th>Summe</th>
                    </tr>
                </thead>
                <tbody>
                <tr v-if="pfand12">
                    <td>24er Kasten 0,33l Glas vollst.</td>
                    <td>{{pfand12}}</td>
                    <td>€ 5,10 </td>
                    <td> € {{pfand12wert}} </td>
                </tr>
                <tr v-if="pfand1">
                    <td>24er Kasten Glas vollst.</td>
                    <td>{{pfand1}}</td>
                    <td>€ 3,42 </td>
                    <td> € {{pfand1wert}} </td>
                </tr>
                <tr v-if="pfand2">
                    <td>20er Kasten Glas vollst.</td>
                    <td>{{pfand2}}</td>
                    <td>€ 3,10 </td>
                    <td>€ {{pfand2wert}} </td>
                </tr>
                <tr v-if="pfand3">
                    <td>11er Kasten Glas vollst.</td>
                    <td>{{pfand3}}</td>
                    <td>€ 2,38</td>
                    <td>€ {{pfand3wert}} </td>
                </tr>
                <tr v-if="pfand4">
                    <td>6er Kasten Glas vollst.</td>
                    <td>{{pfand4}}</td>
                    <td>€ 2,40 </td>
                    <td>€ {{pfand4wert}} </td>
                </tr>
                <tr v-if="pfand11">
                    <td>12er Plastik/20er Glas vollst.</td>
                    <td>{{pfand11}}</td>
                    <td>€ 4,50 </td>
                    <td>€ {{pfand11wert}} </td>
                </tr>
                <tr v-if="pfand5">
                    <td>12er Kasten Plastik vollst.</td>
                    <td>{{pfand5}}</td>
                    <td>€ 3,30 </td>
                    <td>€ {{pfand5wert}} </td>
                </tr>
                <tr v-if="pfand6">
                    <td>6er Kasten Plastik vollst.</td>
                    <td>{{pfand6}}</td>
                    <td>€ 3,00 </td>
                    <td>€ {{pfand6wert}} </td>
                </tr>
                <tr v-if="pfand10">
                    <td>Kasten leer</td>
                    <td>{{pfand10}}</td>
                    <td>€ 1,50</td>
                    <td>€ {{pfand10wert}} </td>
                </tr>
                <tr v-if="pfand7">
                    <td>Mehrweg-Flasche</td>
                    <td>{{pfand7}}</td>
                    <td>€ 0,15 </td>
                    <td>€ {{pfand7wert}} </td>
                </tr>
                <tr v-if="pfand8">
                    <td>Einweg-Flasche/Dose</td>
                    <td>{{pfand8}}</td>
                    <td>€ 0,25 </td>
                    <td>€ {{pfand8wert}} </td>
                </tr>
                <tr v-if="pfand9">
                    <td>Glasflasche</td>
                    <td>{{pfand9}}</td>
                    <td>€ 0,08 </td>
                    <td>€ {{pfand9wert}} </td>
                </tr>
                <tr>
                    <td colspan='2'></td>
                    <td><b>Summe:</b></td>
                    <td><b>€ {{summe}}</b></td>
                </tr>
                </tbody>
            </table>
        </div>
        <br>
        <div class="instruction">
            <p>Ihre Unterschrift:</p>
            <img v-bind:src="signature" width="50%" height="50%"/>
        </div>
        <button class="btn btn-sm btn-danger float-left" v-on:click="cancel()" type="button">abbrechen</button>           
        <button class="btn btn-sm btn-success float-right" :disabled="sendButtonDisabled" v-on:click="send()" type="button">absenden</button>
    </card>


        <div class="alert alert-success" v-if="tick === 4" id="alert">
            <button type="button" aria-hidden="true" class="close"></button>
            <span>
            <b>Erfolgreich versendet! - </b> Eine entsprechende E-Mail inkl. Lieferschein wurde erstellt und versendet.</span>
        </div>
    </div>
</template>

<script>
const numbro = require("numbro");
const lang = require('../../../node_modules/numbro/dist/languages.min.js');
numbro.registerLanguage(lang['de-DE'])
numbro.setLanguage('de-DE');
export default {
  name: 'MySignaturePad',
  components: {

  },
  data() {
    return {
       titleSignature: "Pfandrückgabe | Unterschrift",
       title: "",
       subtitle: "",
       tick: 1,
       pfand1: "", // count
       pfand2: "",
       pfand3: "",
       pfand4: "",
       pfand5: "",
       pfand6: "",
       pfand7: "",
       pfand8: "",
       pfand9: "",
       pfand10: "",
       pfand11: "",
       pfand12: "",
       kundennr: "",
       signature: "", //stores base64 code
       pfand1wert: "", // value
       pfand2wert: "",
       pfand3wert: "",
       pfand4wert: "",
       pfand5wert: "",
       pfand6wert: "",
       pfand7wert: "",
       pfand8wert: "",
       pfand9wert: "",
       pfand10wert: "",
       pfand11wert: "",
       pfand12wert: "",
       summe: "",
       kunde: {},
       sendButtonDisabled: false
    };
  },
  methods: {
    fetchCustomer(){
        this.kundennr = this.$route.params.kundennr;    
         this.$http.post(process.env.VUE_APP_PHP_API_URL+'/kunden/'+ this.kundennr, {auth: process.env.VUE_APP_PHP_AUTH})
            .then(function(kunde){
                console.log(kunde);
                 this.title = "Pfandrückgabe";
                 this.kunde = kunde.body;
                if (this.kunde.Firma.length < 2) {
                    this.subtitle = this.kunde.Nachname;
                }
                else{
                    this.subtitle = this.kunde.Firma;
                }
                
            });
    },
    nextTick(){
        this.tick =  this.tick + 1;
    },
    cancel(){
         this.tick = 1;
    },
    saveSign() {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        if (!isEmpty) {
            this.signature = data;
            this.nextTick();
            this.calculateSum();
            console.log(this.signature);
        }
      },
      calculateSum(){
          let calcpfand1wert = this.pfand1 * 3.42;
          let calcpfand2wert = this.pfand2 * 3.10;
          let calcpfand3wert = this.pfand3 * 2.38;
          let calcpfand4wert = this.pfand4 * 2.40;
          let calcpfand5wert = this.pfand5 * 3.30;
          let calcpfand6wert = this.pfand6 * 3.00;
          let calcpfand7wert = this.pfand7 * 0.15;
          let calcpfand8wert = this.pfand8 * 0.25;
          let calcpfand9wert = this.pfand9 * 0.08;
          let calcpfand10wert = this.pfand10 * 1.50;
          let calcpfand11wert = this.pfand11 * 4.50;
          let calcpfand12wert = this.pfand12 * 5.10;
          let sum =  calcpfand1wert +  calcpfand2wert +  calcpfand3wert +  calcpfand4wert +  calcpfand5wert +  calcpfand6wert +  calcpfand7wert +  calcpfand8wert +  calcpfand9wert +  calcpfand10wert +  calcpfand11wert + calcpfand12wert;
          this.summe = numbro(sum).format({mantissa: 2});
          this.pfand1wert = numbro(calcpfand1wert).format({mantissa: 2});
          this.pfand2wert = numbro(calcpfand2wert).format({mantissa: 2});
          this.pfand3wert = numbro(calcpfand3wert).format({mantissa: 2});
          this.pfand4wert = numbro(calcpfand4wert).format({mantissa: 2});
          this.pfand5wert = numbro(calcpfand5wert).format({mantissa: 2});
          this.pfand6wert = numbro(calcpfand6wert).format({mantissa: 2});
          this.pfand7wert = numbro(calcpfand7wert).format({mantissa: 2});
          this.pfand8wert = numbro(calcpfand8wert).format({mantissa: 2});
          this.pfand9wert = numbro(calcpfand9wert).format({mantissa: 2});
          this.pfand10wert = numbro(calcpfand10wert).format({mantissa: 2});
          this.pfand11wert = numbro(calcpfand11wert).format({mantissa: 2});
          this.pfand12wert = numbro(calcpfand12wert).format({mantissa: 2});
          console.log(this.summe);
      },
       send(){
        //send data to api
        this.sendButtonDisabled = true;

            var email;
            if (this.pfand1 == ""){
                this.pfand1 = 0;
            }
            if (this.pfand2 == ""){
                this.pfand2 = 0;
            }
            if (this.pfand3 == ""){
                this.pfand3 = 0;
            }
            if (this.pfand4 == ""){
                this.pfand4 = 0;
            }
            if (this.pfand5 == ""){
                this.pfand5 = 0;
            }
            if (this.pfand6 == ""){
                this.pfand6 = 0;
            }
            if (this.pfand7 == ""){
                this.pfand7 = 0;
            }
            if (this.pfand8 == ""){
                this.pfand8 = 0;
            }
            if (this.pfand9 == ""){
                this.pfand9 = 0;
            }
            if (this.pfand10 == ""){
                this.pfand10 = 0;
            }
            if (this.pfand11 == ""){
                this.pfand11 = 0;
            }
            if (this.pfand12 == ""){
                this.pfand12 = 0;
            }

            //Check if customer is a company, if not send email to Rewe Uhl Email and not to customer
            if(this.kunde.Firma.length > 2 || this.kunde.Typ == "Kredit"){
                email = this.kunde["E-Mail"];
            }else{
                email = process.env.VUE_APP_EMAIL_LEERGUT
            }
            let data = {
                kundennummer: this.kundennr,
                pfand1: this.pfand1,
                pfand2: this.pfand2,
                pfand3: this.pfand3,
                pfand4: this.pfand4,
                pfand5: this.pfand5,
                pfand6: this.pfand6,
                pfand7: this.pfand7,
                pfand8: this.pfand8,
                pfand9: this.pfand9,
                pfand10: this.pfand10,
                pfand11: this.pfand11,
                pfand12: this.pfand12,
                signature: this.signature,
                firma: this.kunde.Firma,
                hausnummer: this.kunde.Hausnummer,
                nachname: this.kunde.Nachname,
                vorname: this.kunde.Vorname,
                plz: this.kunde.PLZ,
                strasse: this.kunde.Strasse,
                stadt: this.kunde.Stadt,
                email: email,
                auth: process.env.VUE_APP_PHP_AUTH
            };
              this.$http.post(process.env.VUE_APP_PHP_API_URL+'/lieferschein/add', data).then(response => {  
                console.log(response)
                if(response.status == '200'){
                    this.nextTick();
                    setTimeout( () => this.$router.push({ path: '/tagestour'}), 2500);
                }
              });  

            // let pfand1 = this.pfand1wert;
            // let pfand2 = this.pfand2wert;
            // let pfand3 = this.pfand3wert;
            // let pfand4 = this.pfand4wert;
            // let pfand5 = this.pfand5wert;
            // let pfand6 = this.pfand6wert;
            // let pfand7 = this.pfand7wert;
            // let pfand8 = this.pfand8wert;
            // let pfand9 = this.pfand9wert;
            // let pfand10 = this.pfand10wert;
            
    },
  },

  created: function(){
      this.fetchCustomer();
  },
  // updated: function(){
  // }
};
</script>

<style scoped>
#inputmenge{
    width: 100%;
}
#frame{
    margin-left: 0%;
}
.instruction{
    text-align: center;
    font-weight: bold;
}
.pad{
  border: 2px solid rgb(117, 108, 108);
  border-radius: 5px ;
}
</style>


